import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=251cec40&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=ts&"
export * from "./Train.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251cec40",
  null
  
)

export default component.exports